import { render, staticRenderFns } from "./CreateHotel.vue?vue&type=template&id=6cf78de6"
import script from "./CreateHotel.vue?vue&type=script&lang=js"
export * from "./CreateHotel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports